import axios from "axios";
const shipmentApi = process.env.REACT_APP_INVOICE_API_CONFIG;

const env = process.env.REACT_APP_ENV;

const parsedUrl = new URL(window.location.href);
const cmBaseUrl = `${parsedUrl.protocol}//${parsedUrl.host}`;

export const getShipments = async (formattedStartDate, formattedEndDate, userId) => {
    try {
        let path = `/invoice/list`;
        const response = await axios.get(
            shipmentApi + path + `?startDate=${formattedStartDate}&endDate=${formattedEndDate}&company=${localStorage.getItem('companyName')}&userId=${(userId && userId !== 'all') ? userId : ''}`
        );
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getRateConfirmations = async (formattedStartDate, formattedEndDate, userId) => {
    try {
        let path = `/rateConfirmation/list`;
        const response = await axios.get(
            shipmentApi + path + `?startDate=${formattedStartDate}&endDate=${formattedEndDate}&company=${localStorage.getItem('companyName')}&userId=${(userId && userId !== 'all') ? userId : ''}`
        );
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getPods = async (formattedStartDate, formattedEndDate, userId) => {
    try {
        let path = `/pod/list`;
        const response = await axios.get(
            shipmentApi + path + `?startDate=${formattedStartDate}&endDate=${formattedEndDate}&company=${localStorage.getItem('companyName')}&userId=${(userId && userId !== 'all') ? userId : ''}`
        );
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getShipmentDetails = async (formattedStartDate, formattedEndDate, userId) => {
    console.log(userId);
    try {
        const path = `/shipmentDetails`;
        const companyUuid = localStorage.getItem('selectedCompanyUuid') ? localStorage.getItem('selectedCompanyUuid') : JSON.parse(localStorage.getItem('userDetails')).company_uuid;
        const userQuery = userId && userId !== 'all' ? `&userId=${userId}` : '';
        const url = `${shipmentApi}${path}?company_uuid=${companyUuid}&startDate=${formattedStartDate}&endDate=${formattedEndDate}${userQuery}`;
        const response = await axios.get(url);
        console.log(response);
        return response;
    } catch (error) {
        console.error("Unable to fetch shipments", error);
        return "Unable to fetch shipments";
    }
};

export const deleteShipmentDetails = async (uuid) => {
    try {
        let path = `/shipmentDetails`;
        const response = await axios.delete(shipmentApi + path + `?uuid=${uuid}`);
        console.log(response);
        return response;
    } catch (error) {
        console.error('Failed to delete shipment:', error);
        return "Unable to delete shipment";
    }
};

export const updateShipmentDetails = async (data) => {
    try {
        let path = `/shipmentDetails`;
        const response = await axios.put(shipmentApi + path, data);
        return response;
    } catch (error) {
        return "Unable to update shipment details";
    }
};

export const createShipmentDetail = async (data) => {
    try {
        let path = `/shipmentDetails`;
        const response = await axios.post(shipmentApi + path, data);
        return response;
    } catch (error) {
        return "Unable to update shipment details";
    }
};

export const getShipmentByOrder = async (order_number) => {
    try {
        let path = `/invoice/order/${order_number}`;
        const response = await axios.get(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`);
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getUnlinkedPdfs = async (fileName, startDate, endDate) => {
    if (fileName === undefined) {
        fileName = '';
    }
    try {
        let path = `/unlinked/pdf`;
        const response = await axios.get(shipmentApi + path + `?company=${localStorage.getItem('companyName')}&fileName=${fileName}&startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const updateLink = async (data) => {
    try {
        let path = `/pod/link`;
        const response = await axios.put(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`, data);
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const unlinkDocument = async (data) => {
    try {
        let path = `/unlinkDoc`;
        const response = await axios.put(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`, data);
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getFilteredInvoices = async (formattedStartDate, formattedEndDate) => {
    try {
        let path = `/invoices/date`;
        const response = await axios.get(shipmentApi + path + `?startDate=${formattedStartDate}&endDate=${formattedEndDate}&company=${localStorage.getItem('companyName')}`);
        return response;
    } catch (error) {
        return "Unable to fetch shipments";
    }
};

export const getSummaryDetails = async (startDate, endDate, transferType, signature, selectedRowIds) => {
    console.log('transferType', transferType);
    console.log('signature', signature);
    console.log("selectedRows", selectedRowIds);
    try {
        let path = '/invoices/summary/export';
        let queryParams = `?company=${encodeURIComponent(localStorage.getItem('companyName'))}`;
        if (startDate && endDate) {
            queryParams += `&startDate=${startDate}&endDate=${endDate}`;
        }
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        const data = {
            'transferType': transferType,
            'signature': signature,
            'selectedRowIds': selectedRowIds,
            'company_uuid': userDetails?.company_uuid
        };
        console.log("data", data);
        const response = await axios.post(shipmentApi + path + queryParams, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error('Error fetching summary details:', error);
        return {
            statusCode: 504,
            message: "Unable to fetch summary details",
        };
    }
};

export const postDocuments = async (fileData) => {
    const path = '/upload';
    const queryParams = `?company=${localStorage.getItem('companyName')}`;
    const data = {
        files: fileData,
    };
    try {
        const response = await axios.post(shipmentApi + path + queryParams, data);
        return response;
    } catch (error) {
        return 'Unable to upload Documents';
    }
};

export const authorize = async () => {
    const path = '/qb/authentication';
    console.log(localStorage);
    const data = {
        clientId: localStorage.getItem('clientId'),
        clientSecret: localStorage.getItem('clientSecret'),
        redirectUri: `${cmBaseUrl}/qb`,
    };
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const callback = async (code) => {
    const path = '/qb/callback';
    console.log(localStorage);
    const data = {
        code: code,
        clientId: localStorage.getItem('clientId'),
        clientSecret: localStorage.getItem('clientSecret'),
        redirectUri: `${cmBaseUrl}/qb`,
    };
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const getQuickBooksCreds = async () => {
    const path = '/invoice/credentials';
    console.log(localStorage.getItem('userDetails'));
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const queryParams = `?company_id=${userDetails?.company_uuid}`;
    try {
        const response = await axios.get(shipmentApi + path + queryParams);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const insertQuickBooksCreds = async (clientId, clientSecret) => {
    const path = '/invoice/credentials';
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const company_uuid = `${userDetails?.company_uuid}`;
    const data = {
        client_id: clientId,
        client_secret: clientSecret,
        company_uuid: company_uuid,
    };
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const updateQuickBooksCreds = async (clientId, clientSecret, client_credentials_uuid) => {
    const path = '/invoice/credentials';
    const data = {
        clientId: clientId,
        clientSecret: clientSecret,
        client_credentials_uuid: client_credentials_uuid,
    };
    try {
        const response = await axios.put(shipmentApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const getQuickBooksCustomerList = async (companyName) => {
    const data = {
        realmId: localStorage.getItem('realmId'),
        accessToken: JSON.parse(localStorage.getItem('access_token')).value,
        companyName: companyName,
    };
    const path = `/quickbooks/companies`;
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response.data;
    } catch (error) {
        console.error('Error fetching QuickBooks customer list:', error);
        throw error;
    }
};

export const getQuickBooksTermsList = async () => {
    const data = {
        realmId: localStorage.getItem('realmId'),
        accessToken: JSON.parse(localStorage.getItem('access_token')).value,
    };
    const path = `/quickbooks/terms`;
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response.data;
    } catch (error) {
        console.error('Error fetching QuickBooks customer list:', error);
        throw error;
    }
};

export const getQuickBooksServiceList = async () => {
    const data = {
        realmId: localStorage.getItem('realmId'),
        accessToken: JSON.parse(localStorage.getItem('access_token')).value,
    };
    const path = `/quickbooks/services`;
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response.data;
    } catch (error) {
        console.error('Error fetching QuickBooks service list:', error);
        throw error;
    }
};

export const createInvoice = async (data) => {
    const path = `/quickbooks/create/invoice`;
    const finalData = {
        authData: {
            realmId: localStorage.getItem('realmId'),
            accessToken: JSON.parse(localStorage.getItem('access_token')).value,
        },
        data: data,
    };
    try {
        const response = await axios.post(shipmentApi + path, finalData);
        return response?.data;
    } catch (error) {
        console.error('Error fetching QuickBooks service list:', error);
        throw error;
    }
};

export const saveInvoice = async (invoiceId) => {
    const path = `/invoice/save`;
    const data = {
        realmId: localStorage.getItem('realmId'),
        accessToken: JSON.parse(localStorage.getItem('access_token')).value,
        invoiceId: invoiceId,
        companyName: localStorage.getItem('companyName'),
        userId: localStorage.getItem('user_id'),
    };
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response?.data;
    } catch (error) {
        console.error('Error fetching QuickBooks service list:', error);
        throw error;
    }
};

export const updateInvoice = async (data) => {
    try {
        let path = `/invoice/update`;
        console.log("Invoice data", data);
        const response = await axios.put(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`, data);
        return response;
    } catch (error) {
        return "Unable to Update Invoice Details";
    }
};

export const updateRateConfirmation = async (data) => {
    try {
        let path = `/rateConfirmation/update`;
        console.log("Rc data", data);
        const response = await axios.put(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`, data);
        return response;
    } catch (error) {
        return "Unable to Update Rc Details";
    }
};

export const updatePod = async (data) => {
    try {
        let path = `/pod/update`;
        console.log("Pod data", data);
        const response = await axios.put(shipmentApi + path + `?company=${localStorage.getItem('companyName')}`, data);
        return response;
    } catch (error) {
        return "Unable to Update Pod Details";
    }
};

export const triggerShipment = async (payload) => {
    try {
        const path = '/pod/data'; // Adjust the API endpoint as needed
        const response = await axios.post(shipmentApi + path, payload);
        return response;
    } catch (error) {
        console.error('Error triggering shipment:', error);
        throw error;
    }
};
export const getInvoiceByDocNumber = async (inv_number) => {
    const data = {
        realmId: localStorage.getItem('realmId'),
        accessToken: JSON.parse(localStorage.getItem('access_token')).value,
        docNumber: inv_number,
    };
    const path = `/quickbooks/invoice`;
    try {
        const response = await axios.post(shipmentApi + path, data);
        return response.data;
    } catch (error) {
        console.error('Error Fetching the invoice using docNumber', error);
        throw error;
    }
};